import Head from "next/head";
import { Layout } from "@/components/Layout";
import { PageTitle } from "@/components/PageTitle";
import { SectionContainer } from "@/components/SectionContainer";

export default function PrivacyPolicy() {
  const pageTitle = "Privacy Policy";
  return (
    <>
      <Head>
        <title>{`${pageTitle} - Govern For California`}</title>
        <meta
          name="description"
          content="Govern For California's privacy policy"
        />
      </Head>
      <Layout mobileTitle={pageTitle}>
        <PageTitle title={pageTitle} />
        <SectionContainer
          bgColor={"bg-white"}
          className="sm:mt-6"
          aria-label="Information we collect about you"
        >
          <div className="lg:col-span-2">
            <h2 className="mt-2 text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
              1. Information we collect about you
            </h2>
            <p className="mt-5 text-base sm:mx-auto sm:text-center lg:mx-0 lg:text-left lg:text-lg">
              We collect personal information about you in the following ways:
            </p>
            <ul className="ml-6 mt-5 list-outside list-disc text-left text-base  lg:text-lg">
              <li>
                When you subscribe to our mailing list or RSVP to any of our
                events, we collect your first name, last name, email address and
                zip code.
              </li>
              <li>
                When you donate to our 501(c)(4) non-profit organization or to a
                political donation slate we provide of GFC Courage Committee
                chapters and/or candidates, we collect your full name, email
                address, billing address and phone number. In addition, we
                collect your credit card number, expiration date and CVV
                security code, or your bank account and routing numbers in order
                to process the payment for the donation. (Your credit card
                number, expiration date, CVV security code, bank account number
                and routing number are never stored in our databases.) Finally,
                if you are making a political donation, we collect your employer
                and occupation information as required by state law for public
                reporting purposes. (Note: donations to Govern for Californiaʼs
                501(c)(4) non-profit organization are not publicly reported.)
              </li>
              <li>
                When you contact us via email or phone, we will collect your
                name and email address or phone number so we can track follow up
                with you appropriately.
              </li>
              <li>
                When filling out one of our online forms used to RSVP to events
                or to donate, if you select the option to save your information
                using FastAction in order to remember the information next time
                you fill out a form, your information will be saved in
                accordance with the{" "}
                <a
                  className="body-link"
                  href="https://www.everyaction.com/privacy-policy-2/"
                  target="_blank"
                  rel="noreferrer"
                >
                  FastAction by EveryAction Privacy Policy
                </a>
                .
              </li>
              <li>
                When you sign GFC letters of support or opposition to a bill, we
                collect your full name, address and signature for filling on the
                letter.
              </li>
            </ul>
          </div>
        </SectionContainer>
        <SectionContainer
          bgColor={"bg-white"}
          pt={1}
          aria-label="Information we collect about you"
        >
          <div className="m-0 lg:col-span-2">
            <h2 className="mt-2 text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
              2. Information we collect when you use our websites
            </h2>
            <p className="mt-5 text-base sm:mx-auto sm:text-center lg:mx-0 lg:text-left lg:text-lg">
              We do not collect any personal tracking information about how you
              use our website properties at governforcalifornia.org. The only
              information we collect is when you take action with us by filling
              out a subscribe, RSVP, letter signing or donation form as
              described in section 1.
            </p>
          </div>
        </SectionContainer>
        <SectionContainer
          bgColor={"bg-white"}
          pt={1}
          aria-label="Information we collect about you"
        >
          <div className="m-0 lg:col-span-2">
            <h2 className="mt-2 text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
              3. How we use your personal information, and how to delete your
              information
            </h2>
            <p className="mt-5 text-base sm:mx-auto sm:text-center lg:mx-0 lg:text-left lg:text-lg">
              All personal information we collect including your full name,
              email address, address and/or phone numbers are stored securley in
              our CRM database (with the exception of payment method details,
              which are never stored) and will be never shared outside of Govern
              For California. We use your information to send you periodic
              communications from GFC as well as track your contribution and
              contact history with us. You may opt out of our communications at
              any time by visiting{" "}
              <a
                className="body-link"
                href="https://action.governforcalifornia.org/a/self_service"
                target="_blank"
                rel="noreferrer"
              >
                this link
              </a>
              . Additionally, if desired you may request all of your data with
              us be permanently deleted by emailing us at{" "}
              <a
                className="body-link"
                href="mailto:info@governforcalifornia.org"
              >
                info@governforcalifornia.org
              </a>
              .
            </p>
            <p className="mt-5 text-base sm:mx-auto sm:text-center lg:mx-0 lg:text-left lg:text-lg">
              When you opt to save your information via FastAction for use the
              next time you fill out one of our forms, that information is saved
              in accordance with the{" "}
              <a
                className="body-link"
                href="https://www.everyaction.com/privacy-policy-2/"
                target="_blank"
                rel="noreferrer"
              >
                FastAction by EveryAction Privacy Policy
              </a>
              .
            </p>
          </div>
        </SectionContainer>
        <SectionContainer
          bgColor={"bg-white"}
          pt={1}
          aria-label="Information we collect about you"
        >
          <div className="m-0 lg:col-span-2">
            <h2 className="mt-2 text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
              4. How long we keep information
            </h2>
            <p className="mt-5 text-base sm:mx-auto sm:text-center lg:mx-0 lg:text-left lg:text-lg">
              We generally keep the personal information you provide us as
              described in the prior sections indefinitely, unless you provide
              us with a written request to permanently delete your information
              as described in section 3.
            </p>
          </div>
        </SectionContainer>
      </Layout>
    </>
  );
}
